import Vue from 'vue';

const VUE_APP_AUTH_BASE_URL = process.env.VUE_APP_AUTH_BASE_URL;

export const logoutRequest = () => {
  return Vue.axios.post(`${VUE_APP_AUTH_BASE_URL}/authorization/logout`);
};

export const ssoLogoutRequest = () => {
  return Vue.axios.post(`${VUE_APP_AUTH_BASE_URL}/sso/logout`);
};
